
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import {
    mapToDesktopApplicationViewModels,
    mapToWebApplicationViewModel,
    ProductViewModel,
} from 'src/viewModels/Products';
import AppContext from '../AppContext';
import { GetAllProductsPayload } from './generated/types';


const query = `
  query GetAllProducts {
      getAllProducts {
        webApplications {
            productType
            url
        }
        products {
            productType
            productDefinitions {
                downloadUrl
                releaseDate
                version
                type
                whatsNewUrl {
                    de
                    en
                }
            }
        }
    }
}
`;

export const useGetAllProducts = (userId: string) => {
    const context = useContext(AppContext);

    return useQuery<ProductViewModel>({
        queryKey: ['getAllProducts', userId],
        queryFn: async () => {
            const response = await (context.api.graphql({ query }) as Promise<{
                data: {
                    getAllProducts: GetAllProductsPayload;
                };
            }>);

            const { webApplications, products } = response.data.getAllProducts;
            const webApps = webApplications.map(mapToWebApplicationViewModel);
            const desktopApps = mapToDesktopApplicationViewModels(products);

            const result = [
                ...webApps,
                ...desktopApps,
            ].sort((a, b) => a.productName.localeCompare(b.productName));

            return result;
        },
        enabled: !!userId,
    });
};

